export const ErrCodes = [
	{
		"1000":"Oops…Your payment didn’t go through!",
		"1001":"Oops…Invalid request for the payment gateways!",
		"1002":"Oops…Unable to update the order, please try again.",
		"2001":"Payment success !"
	}
]